import dayjs from 'dayjs';
import {
  addInternationalGroupMember,
  deleteInternationalGroupMember,
  replaceInternationalGroupMember,
  updateInternationalGroupMember,
} from '../../../endpoints/chaptersTs';

export const INTL_GROUP_TYPE_OVERSEAS = '4cbd73f4433f446f91b4fbc4d5e3d169';
export const INTL_GROUP_TYPE_STANDING_COMMITTEES =
  '3e0d842a620d4ee79c6c1adeb0090583';
export const INTL_GROUP_TYPE_STANDING_APPOINTMENTS =
  '03839da6ba6346a9b0f35839e012d56a';
export const INTL_GROUP_TYPE_EXECUTIVE_BOARD =
  '8d352c6f74b4498bb471fb609d582558';

export type IntlSaveData = {
  id?: string;
  positionId?: string;
  committeeId?: string | null;
  action: 'newAppointment' | 'editDates' | 'removeRecord';
  userId?: string;
  startDate?: string | null;
  endDate?: string | null;
};

export const formatDateForAPI = (
  dateString: string | null | undefined
): string | null => {
  if (!dateString) return null;
  const date = dayjs(dateString);
  return date.isValid() ? date.format('YYYY-MM-DD') : null;
};

/** Dispatches PositionDisplay save actions to international member CRUD APIs. */
export async function saveIntlLeadershipPosition(
  position: IntlSaveData
): Promise<void> {
  const groupId = position.committeeId?.trim();
  if (!groupId) {
    throw new Error('group id is required');
  }

  if (position.action === 'newAppointment') {
    if (!position.id) {
      await addInternationalGroupMember({
        groupId,
        user_id: position.userId || '',
        position_id: position.positionId || '',
        start_date: formatDateForAPI(position.startDate) || '',
        end_date: formatDateForAPI(position.endDate),
      });
    } else {
      await replaceInternationalGroupMember({
        groupId,
        memberId: position.id,
        user_id: position.userId || '',
        start_date: formatDateForAPI(position.startDate) || '',
        end_date: formatDateForAPI(position.endDate),
      });
    }
    return;
  }

  if (position.action === 'editDates') {
    if (!position.id) {
      throw new Error('member id is required');
    }
    await updateInternationalGroupMember({
      groupId,
      memberId: position.id,
      start_date: formatDateForAPI(position.startDate) || undefined,
      end_date: formatDateForAPI(position.endDate),
    });
    return;
  }

  if (position.action === 'removeRecord') {
    if (!position.id) {
      throw new Error('member id is required');
    }
    await deleteInternationalGroupMember({
      groupId,
      memberId: position.id,
    });
  }
}
